import './index.scss'
import 'swiper/css'
import { Link } from 'gatsby'
import React, { useRef } from 'react'
import ArrowButton from '../ArrowButton'
import { Swiper, SwiperSlide } from 'swiper/react'
import useSlider from '../../hooks/useSlider'

const BlogSlide = ({ item }) => {
  return (
    <a
      href={item.link ? item.link : ''}
      className={`blog-slider__item
        ${item.whiteColor ? 'blog-slider__item--white' : ''}
        ${item.blackColor ? 'blog-slider__item--black' : ''}`}
    >
      {item.image && (
        <div className="blog-slider__background">{item.image}</div>
      )}
      <div className="blog-slider__tag">{item.tag}</div>
      <div className="blog-slider__title">
        <h3>{item.headline}</h3>
      </div>
      <div className="blog-slider__subheadline">
        <h4>{item.subheadline}</h4>
      </div>
      {item.readingTime && (
        <div className="blog-slider__reading-time">
          {item.readingTime} Min. lesen
        </div>
      )}
      {item.bottomText && (
        <div className="blog-slider__reading-time">{item.bottomText}</div>
      )}
    </a>
  )
}

const BlogSlider = ({ singleRow, cards, title }) => {
  const swiperRef = useRef(null)
  const { onInit, isEnd, isBeginning, nextSlide, prevSlide, handleDrag } =
    useSlider(swiperRef)

  const options = {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      630: {
        slidesPerView: singleRow ? 1 : 2,
      },
      1024: {
        slidesPerView: singleRow ? 1 : 3,
      },
      1482: {
        slidesPerView: singleRow ? 2 : 4,
      },
    },
  }

  const sliderItemGroup = cards.reduce((result, value, index, array) => {
    if (index % 2 === 0) result.push(array.slice(index, index + 2))
    return result
  }, [])

  return (
    <div className="blog-slider">
      <div className="container">
        {title && (
          <div className="blog-slider__headline headline">
            <h2>{title}</h2>
          </div>
        )}
        <div className="blog-slider__container">
          <Swiper {...options} onBeforeInit={onInit} onSlideChange={handleDrag}>
            {sliderItemGroup.map((item, index) => (
              <SwiperSlide
                key={index}
                virtualIndex={index}
                className={`swiper-slide ${singleRow ? 'swiper-slide--single-row' : ''}`}
              >
                {item.map((item, indexSlide) => (
                  <BlogSlide key={indexSlide} item={item} />
                ))}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="blog-slider__bottom">
          <div className="blog-slider__button-wrapper">
            <ArrowButton
              full
              onClick={prevSlide}
              mods={
                isBeginning
                  ? ['left', 'color-orange', 'disable']
                  : ['left', 'color-orange']
              }
              ariaLabel="Zurück"
            />
            <ArrowButton
              full
              onClick={nextSlide}
              mods={
                isEnd
                  ? ['right', 'color-orange', 'disable']
                  : ['right', 'color-orange']
              }
              ariaLabel="Weiter"
            />
          </div>
          <a className="button button--color-black" href="/blog">
            Alle Beiträge
          </a>
        </div>
      </div>
    </div>
  )
}

export default BlogSlider
